import { Button } from "antd";
import React from "react";

import edit from "../../assets/icons/edit-2.svg";

export default function EmailTemplatePreview({
  emailTemplate,
  setSelectedTemplateToEdit,
  setShowEditTemplate,
  selectedTemplate,
  setSelectedTemplate,
  isSms,
}) {
  const { id, name, subject, text } = emailTemplate;

  return (
    <div style={{ 
      backgroundColor: id === selectedTemplate ? "#F6F5FD" : "#ffffff", 
      border: "1px solid #E0DDF7", 
      borderRadius: 10, 
      padding: 10,
      // Minimal constraints:
      width: '100%',
      overflow: 'hidden'
    }}>
      {/* Title with edit and select buttons */}
      <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: 10, }}>
        <p style={{ color: "#6B43B5", marginBottom: 0, fontWeight: 500, fontSize: 16,overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', flex: 1, minWidth: 0 }}>
          {name}
        </p>

        <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
          <div
            style={{ width: 24, height: 24, borderRadius: 100, cursor: "pointer" }}
            onClick={() => {
              setShowEditTemplate(true);
              setSelectedTemplateToEdit(emailTemplate);
            }}
          >
            <img src={edit} alt="edit" />
          </div>

          <Button
            style={{
              backgroundColor: id === selectedTemplate ? "#E0DDF7" : "#6b43b5",
              color: id === selectedTemplate ? "#6B43B5" : "#ffffff",
              padding: "3px 20px",
              borderRadius: 100,
              fontSize: 12,
            }}
            onClick={() => {
              if (id === selectedTemplate) return;
              setSelectedTemplate(id);
            }}
          >
            {id === selectedTemplate ? "Selected" : "Select"}
          </Button>
        </div>
      </div>

      {/* Email Subject */}
      {!isSms && 
        <div>
          <p>{subject}</p>
        </div>
      }

      {/* Email Text */}
      <div>
        <p style={{ color: "#848696", wordWrap: 'break-word', overflowWrap: 'break-word', wordBreak: 'break-word', margin: 0 }}>
          {text}
        </p>
      </div>
    </div>
  );
}
